import { Platform } from "react-native";
import { Alert } from "react-native";
import { PermissionsAndroid } from "react-native";
import CameraRoll from "@react-native-community/cameraroll";
import RNFetchBlob from "rn-fetch-blob";

const getDownloadPermissionAndroid = async () => {
  try {
    const granted = await PermissionsAndroid.request(
      PermissionsAndroid.PERMISSIONS.WRITE_EXTERNAL_STORAGE,
      {
        title: "Image Download Permission",
        message: "Your permission is required to save images to your device",
        buttonNegative: "Cancel",
        buttonPositive: "OK",
      }
    );
    if (granted === PermissionsAndroid.RESULTS.GRANTED) {
      return true;
    }
    Alert.alert(
      "Save remote Image",
      "Grant Me Permission to save Image",
      [{ text: "OK", onPress: () => console.log("OK Pressed") }],
      { cancelable: false }
    );
  } catch (err) {
    Alert.alert(
      "Save remote Image",
      "Failed to save Image: " + err.message,
      [{ text: "OK", onPress: () => console.log("OK Pressed") }],
      { cancelable: false }
    );
  }
};

export const savePrescription = async (url) => {
  // if device is android you have to ensure you have permission
  if (Platform.OS === "android") {
    const granted = await getDownloadPermissionAndroid();
    if (!granted) {
      return;
    }
  }
  let dirs = RNFetchBlob.fs.dirs;
  const splitted = url.split("/");
  const fileName = splitted[splitted.length - 1].match("([^/?]*)");
  try {
    const blob = await RNFetchBlob.config({
      fileCache: true,
      appendExt: "jpg",
      path: `${dirs.PictureDir}/${fileName[0]}`,
    }).fetch("GET", encodeURI(url));
    console.log("savePrescription", { url, blob, fileName });
    const saveToDevice = await CameraRoll.save(blob.data, {
      type: "photo",
      album: "prescription",
    });
    console.log({ saveToDevice });
    Alert.alert(
      "Simpan Resep",
      "Resep berhasil disimpan",
      [{ text: "OK", onPress: () => console.log("OK Pressed") }],
      { cancelable: false }
    );
    return true;
  } catch (error) {
    Alert.alert(
      "Simpan Resep",
      `Resep gagal disimpan. Error:${error}`,
      [{ text: "OK", onPress: () => console.log("OK Pressed") }],
      { cancelable: false }
    );
    return false;
  }
};
